import * as React from "react";

import { Trans } from "react-i18next";

import { Callout } from "@blueprintjs/core";
import { mefDate, mefMontantStr } from "../../utils/mef";
import i18n from "../../i18n";

export default class IRVEFare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    let prop;
    if (this.props.to)
      prop = {
        title:
          i18n.t("old tarif for period") +
          " " +
          mefDate(this.props.from) +
          " - " +
          mefDate(this.props.to),
        intent: "none",
      };
    else
      prop = {
        title: i18n.t("rates in effect since") + " " + mefDate(this.props.from),
        intent: "success",
      };

    return (
      <Callout {...prop}>
        <div className="flexbox-center-large">
          <table>
            <tbody>
              <tr>
                <td></td>
                <td>{mefMontantStr(this.props.price_Kwh)}</td>
                <td>/</td>
                <td>Kwh</td>
              </tr>
              <tr>
                <td>+</td>
                <td>{mefMontantStr(this.props.price_minutes)}</td>
                <td>/</td>
                <td>minute</td>
              </tr>
              <tr>
                <td>+</td>
                <td>{mefMontantStr(this.props.price_session)}</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <Trans>created on:</Trans>
          {mefDate(this.props.creation)}
        </div>
      </Callout>
    );
  }
}
